import type { Plugin } from 'vue';
import { I18nVuePlugin } from '@shared/common/translation/application/vue-plugin/i18n.vue-plugin';
import fr from '@client/translations/fr.json';
import en from '@client/translations/en.json';
import es from '@client/translations/es.json';
import it from '@client/translations/it.json';
import de from '@client/translations/de.json';
import pt from '@client/translations/pt.json';
import pl from '@client/translations/pl.json';
import nl from '@client/translations/nl.json';
import sv from '@client/translations/sv.json';

export const ClientI18nVuePlugin: Plugin = {
  install(app) {
    app.use(I18nVuePlugin, {
      messages: { fr, en, es, it, de, pt, pl, nl, sv },
    });
  },
};
